// extracted by mini-css-extract-plugin
export default {"spotItem":"SpotItem_spotItem__PoRlI","selected":"SpotItem_selected__jU9kP"};